// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.container {
    display: flex;
    flex-direction: row; /* default */
    flex-wrap: wrap;
    overflow-y: scroll;
    width: 100%;
    max-height: 100%;
    position: relative;
    gap: 5px;
    padding: 5px 10px;
    min-height: 350px;
}

.container::after {
    content: '';
    flex-grow: 999999999;
}

/* Intersection observer styles */
.intersection-trigger {
    height: 1px;
    margin-bottom: -1px;
}

.load-previous-element-container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.load-previous-element-container md-elevated-button {
    --md-elevated-button-container-color: var(--outline);
    --md-elevated-button-label-text-color: white;
    --md-elevated-button-hover-state-layer-color: white;
    --md-elevated-button-hover-label-text-color: white;
    --md-elevated-button-focus-label-text-color: white;
    --md-elevated-button-pressed-label-text-color: white;
    --md-elevated-button-pressed-state-layer-color: white;
    --md-elevated-button-container-shape: var(--radius-extra-large);

    height: 30px;
    width: fit-content;
    display: none;
}

.load-previous-element-container md-icon {
    color: white;
}

.mock-report-details-card {
    justify-content: space-between;
}

/* Pagination styles */
.results-grid-pagination-container {
    display: none;
    justify-content: flex-end;
    align-items: center;
    padding: 10px;
    gap: 10px;
    width: 100%;
    height: fit-content;
}

[data-pagination-value] {
    border: 1px solid var(--surface-variant);
    width: 50px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-extra-small);
    cursor: default;
}

[data-pagination-double-right-button] {
    display: none;
}

[data-results-grid-spinner] {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../components/src/layouts/ResultsGridLayout/ResultsGridLayout.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,YAAY;IACjC,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,4CAA4C;IAC5C,mDAAmD;IACnD,kDAAkD;IAClD,kDAAkD;IAClD,oDAAoD;IACpD,qDAAqD;IACrD,+DAA+D;;IAE/D,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n.container {\n    display: flex;\n    flex-direction: row; /* default */\n    flex-wrap: wrap;\n    overflow-y: scroll;\n    width: 100%;\n    max-height: 100%;\n    position: relative;\n    gap: 5px;\n    padding: 5px 10px;\n    min-height: 350px;\n}\n\n.container::after {\n    content: '';\n    flex-grow: 999999999;\n}\n\n/* Intersection observer styles */\n.intersection-trigger {\n    height: 1px;\n    margin-bottom: -1px;\n}\n\n.load-previous-element-container {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n.load-previous-element-container md-elevated-button {\n    --md-elevated-button-container-color: var(--outline);\n    --md-elevated-button-label-text-color: white;\n    --md-elevated-button-hover-state-layer-color: white;\n    --md-elevated-button-hover-label-text-color: white;\n    --md-elevated-button-focus-label-text-color: white;\n    --md-elevated-button-pressed-label-text-color: white;\n    --md-elevated-button-pressed-state-layer-color: white;\n    --md-elevated-button-container-shape: var(--radius-extra-large);\n\n    height: 30px;\n    width: fit-content;\n    display: none;\n}\n\n.load-previous-element-container md-icon {\n    color: white;\n}\n\n.mock-report-details-card {\n    justify-content: space-between;\n}\n\n/* Pagination styles */\n.results-grid-pagination-container {\n    display: none;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 10px;\n    gap: 10px;\n    width: 100%;\n    height: fit-content;\n}\n\n[data-pagination-value] {\n    border: 1px solid var(--surface-variant);\n    width: 50px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-extra-small);\n    cursor: default;\n}\n\n[data-pagination-double-right-button] {\n    display: none;\n}\n\n[data-results-grid-spinner] {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
